export default __webpack_public_path__ + "static/media/85a2b2d75bfea662ef0b8fa1841b6e22.svg";